import { FormItemBase } from './form-item-base';

export class FormItemIntTextBox extends FormItemBase<string> {
  controlType = 'int';
  type: string;
  minValue: number;
  maxValue: number;
  inline: boolean;

  constructor(options: {
    itemType?: string,
    value?: number,
    key?: string,
    label?: string,
    shortlabel?: string,
    altlabel?: string,
    comment?: string,
    required?: boolean,
    order?: number,
    controlType?: string,
    depth?: number,
    isVisible?: boolean,
    isEnabled?: boolean,
    isReadOnly?: boolean,
    invalidValue?: boolean,
    useAltText?: boolean,
    sizeHint?: string,
    weightHint?: string,
    minValue?: number,
    maxValue?: number,
    isTooltipDefined?: boolean,
    errorHint?: string, 
    inline?: boolean
  } = {}) {
    super(options);
    const key = 'type';
    this.type = options[key] || '';
    this.isReadOnly = options.isReadOnly;
    this.value = options.value;
    this.inline = options.inline;

    if (!this.inline) {
      this.labelClass = 'dx-field-label field-label-override form-item-int-label form-item-depth-' + this.depth.toString();
    } else {
      this.labelClass = 'dx-field-label field-label-override form-item-int-label form-item-inline-depth-' + this.depth.toString(); 
    }

    if (options.minValue >= 0) {
      this.minValue = options.minValue;
    } else {
      this.minValue = 0;
    }

    if (options.maxValue >= 0) {
      this.maxValue = options.maxValue;
    } else {
      this.maxValue = Number.MAX_SAFE_INTEGER;
    }

  }
}
